import { Flags } from "@/classes/FeatureFlags";

// Check forms manages form definitions; staff record answers in Checks.
// Share this contract between navigation visibility and the router metadata.
export const checkFormsAccess = {
    roles: ["admin", "auditor"],
    featureFlag: Flags.ChecksModule,
    unavailableRoute: "PageUnavailable"
};

export function canAccessCheckForms({ role, has }) {
    return checkFormsAccess.roles.some(role) && has(checkFormsAccess.featureFlag);
}
